import React, { useEffect, useState } from "react";
import submit from "submit-form";
import PropTypes from "prop-types";
import ProductTabs from "./ProductTabs";
const filters = [
  {
    actionTypes: [
      { title: () => "Onboarding", value: "finished-onboarding" },
      { title: () => "Progress Photos", value: "bodyPhotos" },
      { title: () => "Bodyweight", value: "bodyWeight" },
      { title: () => "Body Measurements", value: "bodyMeasurements" },
      { title: () => "Nutrition", value: "nutrients" },
      { title: () => "Daily Steps", value: "steps" },
    ],
  },
  {
    actionTypes: [
      { title: () => "Daily Sleep", value: "sleep" },
      { title: () => "HRV", value: "hrv" },
      { title: () => "Readiness Rate", value: "readiness" },
      {
        title: () => "Daily Accountabilities",
        value: "completed-accountabilities",
      },
      { title: () => "Check-in's", value: "completed-check-in" },
      { title: () => "Completed Workouts", value: "swipe-completed-workout" },
      {
        title: () => "Onboarding Questionnaire",
        value: "completed-onboarding-check-in",
      },
    ],
  },
  {
    actionTypes: [
      { title: () => "Session RPE", value: "sessionRPE" },
      { title: () => "Uploaded Videos", value: "uploaded-video-set" },
      { title: () => "Set Comment", value: "commented-set" },
      { title: () => "Workout Comment", value: "commented-workout" },
      { title: () => "Check-in Comment", value: "commented-check-in" },
      { title: () => "Check-in Review", value: "watched-check-in-video" },
    ],
  },
  {
    actionTypes: [
      { title: () => "Add Exercises", value: "added-exercise" },
      { title: () => "Remove Exercise", value: "deleted-exercise" },
      { title: () => "Add Program", value: "added-calendar-program" },
      { title: () => "Move Workout", value: "moved-workout" },
    ],
  },
];
const ActivityFiltersModal = (
  { openModal, closeModal, productTypes },
  { locals }
) => {
  if (!openModal) return null;
  const referAsClients = locals.activeUser.referAsClients;
  const {
    query: { actionTypes, productType },
  } = locals;

  const [selectedFilters, setSelectedFilters] = useState([]);
  const selectType = (e) => {
    if (e.target.checked) {
      setSelectedFilters([...selectedFilters, e.target.value]);
    } else {
      setSelectedFilters(
        selectedFilters.filter((selectedF) => selectedF !== e.target.value)
      );
    }
  };
  useEffect(() => {
    if (actionTypes) setSelectedFilters(JSON.parse(actionTypes));
  }, []);
  const submitFilters = () => {
    if (selectedFilters.length > 0 && selectedFilters[0].length !== 0) {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          actionTypes: JSON.stringify(selectedFilters),
          page: 0,
        },
      });
    } else {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          "modal[type]": "activity-feed",
          actionTypes: "",
        },
      });
    }
    closeModal();
  };
  const closeHref = "/actions/refresh?modal[type]=activity-feed";

  return (
    <div role="modal" className="Modal-Box activity-filters-modal">
      <a href={closeHref} onClick={closeModal} className="overlay" />
      <div className="box">
        <header>
          <h2>Filters</h2>
          <button
            onClick={closeModal}
            role="button"
            data-button-type="tertiary"
            data-icon-only="true"
          >
            <img src="/img/new-icons/red-cross.svg" alt="dismiss" />
          </button>
        </header>
        <div className="body">
          <header>
            <div className="unit-container">
              <ProductTabs
                locals={locals}
                productType={productType}
                isButton={true}
              />
            </div>
          </header>
          <div className="content">
            {filters.map((filter) => (
              <section>
                {filter.actionTypes.map((actionType) => (
                  <div>
                    <input
                      type="checkbox"
                      value={actionType.value}
                      name={actionType.value}
                      onClick={selectType}
                      checked={
                        selectedFilters.includes(actionType.value)
                          ? true
                          : undefined
                      }
                    />
                    <label htmlFor={actionType.value}>
                      {actionType.title(referAsClients)}
                    </label>
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={() => setSelectedFilters([])}
          >
            Clear all
          </button>
          <button data-button-type="primary" onClick={submitFilters}>
            Filter
          </button>
        </footer>
      </div>
    </div>
  );
};
ActivityFiltersModal.contextTypes = { locals: PropTypes.object };
export default ActivityFiltersModal;
